import React from 'react'

import { useDispatch,useSelector } from 'react-redux'

import { IModalComponentProps, useModal } from '@context/Modal'
import { IApplicationState } from '@store'
import { clearUIFlag, selectUIFlag, UIFlag } from '@store/ui'

interface IProps<T = IModalComponentProps> {
  uiFlag: UIFlag
  modalComponent: React.ComponentClass<T> | React.FC<T>
  modalComponentProps?: any
}

export const UIFlagWatcherModal: React.FC<IProps> = ({
  uiFlag,
  modalComponent,
  modalComponentProps,
}) => {
  const dispatch = useDispatch()
  const { showModal } = useModal()
  const isActive = useSelector((state: IApplicationState) => selectUIFlag(state, uiFlag))

  React.useEffect(() => {
    if (isActive) {
      showModal(modalComponent, modalComponentProps)
      dispatch(clearUIFlag(uiFlag))
    }
  }, [isActive])

  return null
}

export default UIFlagWatcherModal
